import { useRef } from 'react'

import { uuidv4 } from '@core/helpers/uuidv4'
import { getSessionStorage } from '@core/storage'
import { StorageKeyEssentialEnum } from '@core/storage/types'

export const KEY = StorageKeyEssentialEnum.fw_tab_id

function getOrCreateTabId() {
  const storedTabId = getSessionStorage().getItem(KEY)
  if (storedTabId) {
    return storedTabId
  }
  const newTabId = uuidv4()
  getSessionStorage().setItem(KEY, newTabId)
  return newTabId
}

/**
 * @returns An id that is unique per tab, and maintains the same value through
 * page reloads.
 */
export function useTabId() {
  const tabId = useRef(getOrCreateTabId())

  return tabId.current
}
